import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { SwPush } from "@angular/service-worker";
import { fromEvent, Observable, Subscription } from "rxjs";
// import { NewsletterService } from "../common/service/newsletter.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, OnDestroy {

  // readonly VAPID_PUBLIC_KEY = "BOtsBbm4aD_efgkdL03gmL-4i6q2Q0_ZdTMwlYNDrEMx5fPWSk9iI4IKPPl3JtoX4KaZICsMpcpqMgA1tmyTJpw";

  public releaseDate: string = environment.releaseDate;
  public isOnline: boolean;

  private offlineEvent: Observable<Event>;
  private offLineSubscription: Subscription;
  private onlineEvent: Observable<Event>;
  private onLineSubscription: Subscription;

  constructor(
    private router: Router,
    // private swPush: SwPush,
    // private newsletterService: NewsletterService
  ) {
    // router-events
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // console.log("------------------------------->App:constructor-navigationStart-event", event);
      }
      if (event instanceof NavigationEnd) {
        // console.log("------------------------------->App:constructor-navigationEnd-event", event);
        this.fixViewport(200); // 200ms = sweet spot für OAuth
      }
    });

  }

  // subscribeToNotifications() {
  //   this.swPush.requestSubscription({
  //     serverPublicKey: this.VAPID_PUBLIC_KEY
  //   })
  //     .then(sub => console.log("app:subscribeToNotifications-sub", sub));
  //   // .then(sub => this.newsletterService.addPushSubscriber(sub).subscribe())
  //   // .catch(err => console.error("Could not subscribe to notifications", err));
  // }

  public ngOnInit() {
    this.isOnline = navigator.onLine;
    // console.log("App:ngOnInit-isOnline", this.isOnline);

    this.offlineEvent = fromEvent(window, "offline");
    this.offLineSubscription = this.offlineEvent.subscribe(e => {
      console.log("App:offlineEvent");
      this.isOnline = false;
    });

    this.onlineEvent = fromEvent(window, "online");
    this.onLineSubscription = this.onlineEvent.subscribe(e => {
      console.log("App:onlineEvent");
      this.isOnline = true;
    });

    // Deaktiviert das Zoomen mit zwei Fingern (Pinch-to-Zoom)
    document.addEventListener('touchstart', (event: TouchEvent) => {
      if (event.touches.length > 1) {
        event.preventDefault(); // Verhindert die Zoom-Geste
      }
    }, { passive: false }); // Wichtig: 'passive: false' erlaubt das Blockieren des Events

  }
  public ngOnDestroy() {
    this.offLineSubscription.unsubscribe();
    this.onLineSubscription.unsubscribe();
  }


  private fixViewport(delay = 0) {
    const apply = () => {
      const h = window.innerHeight;
      document.documentElement.style.setProperty('--app-height', `${h}px`);
    };

    if (delay > 0) {
      setTimeout(apply, delay);
    } else {
      apply();
    }
  }
}
